interface CustomButtonProps {
    label: string;
    action: () => void;
    variant?: ButtonVariant;
    isDarkMode?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({ label, action, variant, isDarkMode = false }) => {
    const getButtonClass = () => {
        const baseClasses = "font-bold py-2 px-4 rounded cursor-pointer transition duration-300 ease-in-out";
        
        if (!variant) {
            return isDarkMode 
                ? `bg-white text-black ${baseClasses} hover:bg-white/80` 
                : `bg-black text-white ${baseClasses} hover:bg-black/80`;
        }

        switch (variant) {
            case ButtonVariant.PRIMARY:
                return isDarkMode 
                    ? `bg-white text-black ${baseClasses} hover:bg-white/80`
                    : `bg-black text-white ${baseClasses} hover:bg-black/80`;
            case ButtonVariant.SECONDARY:
                return isDarkMode
                    ? `bg-gray-300 text-black ${baseClasses} hover:bg-gray-400`
                    : `bg-gray-500 text-white ${baseClasses} hover:bg-gray-600`;
            case ButtonVariant.OUTLINE:
                return isDarkMode
                    ? `bg-transparent text-white border border-white ${baseClasses} hover:border-white/80 hover:bg-white/10`
                    : `bg-transparent text-black border border-black ${baseClasses} hover:border-black/80 hover:bg-black/10`;
            case ButtonVariant.TEXT:
                return isDarkMode
                    ? `bg-transparent text-white ${baseClasses} hover:underline`
                    : `bg-transparent text-black ${baseClasses} hover:underline`;
            case ButtonVariant.GHOST:
                return isDarkMode
                    ? `bg-transparent text-white ${baseClasses} hover:bg-gray-800`
                    : `bg-transparent text-black ${baseClasses} hover:bg-gray-100`;
            default:
                return isDarkMode
                    ? `bg-white text-black ${baseClasses} hover:bg-white/80`
                    : `bg-black text-white ${baseClasses} hover:bg-black/80`;
        }
    };

    return (
        <button
            className={getButtonClass()}
            onClick={action}
        >
            {label}
        </button>
    );
}

export default CustomButton;

export enum ButtonVariant {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    OUTLINE = "outline",
    TEXT = "text",
    GHOST = "ghost",
}